'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import ClientOnlySnippet from '@/components/CodeSnippet/ClientOnlySnippet';
import Spinner from '@/components/Spinner';

interface Props {
  code: string;
  minCodeHeight: string;
}

function Snippet({ code, minCodeHeight }: Props) {
  const [hasLoaded, setHasLoaded] = React.useState(false);

  return (
    <CodeWrapper style={{ '--min-code-height': minCodeHeight }}>
      {!hasLoaded && <StyledSpinner />}
      <ClientOnlySnippet
        lockedToColorMode="light"
        omitCopyButton
        onMount={() => setHasLoaded(true)}
        code={code}
        lang="css"
      />
    </CodeWrapper>
  );
}

const CodeWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: var(--min-code-height);
  padding: 0px;
  background: hsl(210deg 20% 20% / 0.05);
  text-align: left;
`;

const StyledSpinner = styled(Spinner)`
  position: absolute;
  top: 16px;
  right: 16px;
  opacity: 0.5;
`;

export default Snippet;
